import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CustomerDiscountAlert from "../components/CustomerDiscountAlert";
import ReviewReminderAlert from "../components/ReviewReminderAlert";

function WebsiteLayout() {
  const location = useLocation();
  const firstRender = useRef(true);
  const [routeLoading, setRouteLoading] = useState(false);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return undefined;
    }

    setRouteLoading(true);
    const timer = window.setTimeout(() => {
      setRouteLoading(false);
    }, 600);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return (
    <>
      <Navbar />
      <WebsiteRouteLoader active={routeLoading} />
      <CustomerDiscountAlert />
      <ReviewReminderAlert />
      <main className={routeLoading ? "website-route-content is-route-loading" : "website-route-content"}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function WebsiteRouteLoader({ active }) {
  return (
    <div
      aria-hidden={!active}
      aria-live="polite"
      className={active ? "website-route-loader is-active" : "website-route-loader"}
      role="status"
    >
      <div className="website-route-loader__bar" />
    </div>
  );
}

export default WebsiteLayout;
